import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import { useSelector } from "react-redux";
import moment from "moment";

const TTDTraineeDetails = (props) => {
  const [data, setData] = useState([]);
  const [index, setIndex] = useState(0);

  const value = useSelector((state) => state.viewDetails);
  useEffect(() => {
    const result = props.data.map((item) => {
      return {
        ...item,
        TTDdate: item.TechTestDate
          ? moment(new Date(item.TechTestDate)).format("YYYY-MM-DD")
          : "",

        TTDrecovery: item.TechTestRecoveryDate
          ? moment(new Date(item.TechTestRecoveryDate)).format("YYYY-MM-DD")
          : "",
      };
    });

    setData(result);
  }, [props]);

  useEffect(() => {
    setIndex(value.index);
  }, [value]);

  return (
    <>
      {data.length > 0 ? (
        <div>
          <Grid className="p-10px" container spacing={2}>
            <Grid item xs={12} container>
              <Grid item xs={3}>
                Attended TTD:
              </Grid>
              <Grid item xs={9}>
                {data[index].AttendedTechTest != null
                  ? data[index].AttendedTechTest === true
                    ? "Yes"
                    : "No"
                  : null}
              </Grid>
              <Grid item xs={3} sx={{ marginTop: 10 }}>
                TTD Type :
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {data[index].TechTestType}
              </Grid>
              <Grid item xs={3} sx={{ marginTop: 10 }}>
                TTD Disposition :
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {data[index].TechTestDisposition}
              </Grid>
              <Grid item xs={3} sx={{ marginTop: 10 }}>
                Failure Reason :
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {data[index].TechTestFailureReason}
              </Grid>
              <Grid item xs={3} sx={{ marginTop: 10 }}>
                TTD Date and Time :
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {data[index].TTDdate} {data[index].TechTestTime}
              </Grid>

              <Grid item xs={3} sx={{ marginTop: 10 }}>
                TTD Zoom Link and Password :
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {data[index].TechTestZoomLink}{" "}
                {data[index].TechTestZoomPassword}
              </Grid>
              <Grid item xs={3} sx={{ marginTop: 10 }}>
                Attended TTD Recovery :
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {" "}
                {data[index].AttendedTechTestRecovery != null
                  ? data[index].AttendedTechTestRecovery === true
                    ? "Yes"
                    : "No"
                  : null}
              </Grid>
              <Grid item xs={3} sx={{ marginTop: 10 }}>
                TTD Recovery Date and Time :
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {data[index].TTDrecovery} {data[index].TechTestRecoveryTime}
              </Grid>
              <Grid item xs={3} sx={{ marginTop: 10 }}>
                TTD Recovery Disposition :
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {data[index].TechTestRecoveryDisposition}
              </Grid>
            </Grid>
          </Grid>
        </div>
      ) : null}
    </>
  );
};

export default TTDTraineeDetails;
